document.addEventListener("click", function (e) {
    if (e.target.matches(".desktop-show .collection-tag")) {
        // Toggle 'active' class on clicked tag (multiple allowed)
        e.target.classList.toggle('active');

        const tagTitle = e.target.getAttribute("title");

        const label = document.querySelector(`.tags-filter .mobile-facets__label[title="${tagTitle}"]`);
        if (label) {
            const input = label.querySelector("input[type='checkbox']");
            if (input) {
                input.click(); // toggle checkbox linked to this tag
            }
        }
    }
});